<template>
  <div class="list-item u_cy2">
    <div class="fl">
      <!-- v-show="currentRoleId == (item.roleId - 1)" -->
      <van-radio
        :name="item.userName"
        class="radio"
        @click="radioClick(item)"
      ></van-radio>
      <h4 class="cap4">{{ item.userName }}</h4>
      <p>{{ roleName }}</p>
      <p class="fcG2">{{ item.school }}</p>
      <p class="fcG2">{{ item.province }}{{ item.city }}{{ item.district }}</p>
    </div>
    <p @click="operation(item)" :class="`btn5 ${statusClass}`">{{ item.statusStr }}</p>
  </div>
</template>

<script>
import { reactive, toRefs, watch, } from "vue";
import { statusClass,  } from "@/common/js";
export default {
  name: "ListItem",
  props: {
    item: {
      type: Object,
    },
    change: {
      type: Function,
    },
    radClick: {
      type: Function,
    },
    currentRoleId: {
      type: Number,
    }
  },

  setup(props) {
    const state = reactive({
      item: props.item,
      statusClass: statusClass(props.item.status),
      roleName: props.item.roleName,
      currentRoleId: props.currentRoleId
    });

    const operation = (item) => {
      const { userName, id, status } = item;
      const { change } = props;
      if (change) {
        props.change(userName, id, status);
      }
    };

    watch(props, (newProps) => {
      state.statusClass = statusClass(newProps.item.status);
    });

    const radioClick = (item) => {
      props.radClick(item);
    };

    return {
      ...toRefs(state),
      operation,
      radioClick,
    };
  },
};
</script>

<style lang="less" scoped>
.list-item {
  position: relative;
  clear: both;
  overflow: hidden;
  font-size: 0.32rem;
  color: #999;
  min-height: 1.6rem;
  line-height: 0.533rem;
  padding: 0.267rem 0.267rem 0.267rem 0;
  border-top: 1px solid #e5e5e5;
}
</style>
